import Wrapper from "./Wrapper";

const TermsCondition = () => {
  return (
    <Wrapper seoTitle="Terms & Condition">
      <div className="content_inner">
        <h4>Terms</h4>
        <p>
          By accessing this website of Kalista Jewels, you are agreeing to be
          bound by these web site Terms and Conditions of Use, all applicable
          laws and regulations, and agree that you are responsible for
          compliance with any applicable local laws. If you do not agree with
          any of these terms, you are prohibited from using or accessing this
          site. The materials contained in this web site are protected by
          applicable copyright and trade mark law.
        </p>
        <h4>Use License</h4>
        <p>
          Permission is granted to temporarily download one copy of the
          materials (information or software) on Kalista Jewels web site for
          personal, non-commercial transitory viewing only. This is the grant of
          a license, not a transfer of title, and under this license you may
          not:
        </p>
        <ul>
          <li>License you may not.</li>
          <li>Modify or copy the materials.</li>
          <li>
            Use the materials for any commercial purpose, or for any public
            display (commercial or non-commercial).
          </li>
          <li>
            Attempt to decompile or reverse engineer any software contained on
            Kalista Jewels web site.
          </li>
          <li>
            Remove any copyright or other proprietary notations from the
            materials.
          </li>
          <li>
            Transfer the materials to another person or “mirror” the materials
            on any other server.
          </li>
        </ul>
        <p>
          This license shall automatically terminate if you violate any of these
          restrictions and may be terminated by Kalista Jewels at any time. Upon
          terminating your viewing of these materials or upon the termination of
          this license, you must destroy any downloaded materials in your
          possession whether in electronic or printed format.
        </p>
        <h4>Disclaimer</h4>
        <p>
          The materials on Kalista Jewels web site are provided “as is”. Kalista
          Jewels makes no warranties, expressed or implied, and hereby disclaims
          and negates all other warranties, including without limitation,
          implied warranties or conditions of merchant-ability, fitness for a
          particular purpose, or non-infringement of intellectual property or
          other violation of rights. Further, Kalista Jewels does not warrant or
          make any representations concerning the accuracy, likely results, or
          reliability of the use of the materials on its Internet web site or
          otherwise relating to such materials or on any sites linked to this
          site.
        </p>
        <p>
          In connection with the Estimated Retail Price provided on each
          Product, on some items Kalista Jewels has utilized information
          provided by specific retailers who have carried those items at retail
          value, and in other instances Kalista Jewels has utilized its
          professional experience and knowledge to provide the most accurate
          retail estimated price possible. Based on the forgoing, in all cases
          where an Estimated Retail Price is provided, it is simply an estimate
          by Kalista Jewels.
        </p>
        <h4>Limitations</h4>
        <p>
          In no event shall Kalista Jewels or its suppliers be liable for any
          damages (including, without limitation, damages for loss of data or
          profit, or due to business interruption,) arising out of the use or
          inability to use the materials on Kalista Jewels Internet site, even
          if Kalista Jewels or a Kalista Jewels authorized representative has
          been notified orally or in writing of the possibility of such damage.
          Because some jurisdictions do not allow limitations on implied
          warranties, or limitations of liability for consequential or
          incidental damages, these limitations may not apply to you.
        </p>
        <h4>Revisions and Errata</h4>
        <p>
          The materials appearing on Kalista Jewels web site could include
          technical, typographical, or photographic errors. Kalista Jewels does
          not warrant that any of the materials on its web site are accurate,
          complete, or current. Kalista Jewels may make changes to the materials
          contained on its web site at any time without notice. Kalista Jewels
          does not, however, make any commitment to update the materials.
        </p>
        <h4>Links</h4>
        <p>
          Kalista Jewels has not reviewed all of the sites linked to its
          Internet web site and is not responsible for the contents of any such
          linked site. The inclusion of any link does not imply endorsement by
          Kalista Jewels of the site. Use of any such linked web site is at the
          user’s own risk.
        </p>
        <h4>Site Terms of Use Modifications</h4>
        <p>
          Kalista Jewels may revise these terms of use for its web site at any
          time without notice. By using this web site you are agreeing to be
          bound by the then current version of these Terms and Conditions of
          Use.
        </p>
        <h4>Governing Law</h4>
        <p>
          Any claim relating to Kalista Jewels web site shall be governed by the
          laws of the State of California without regard to its conflict of law
          provisions.
        </p>
      </div>
    </Wrapper>
  );
};

export default TermsCondition;
